export const DEV_MODE = process.env.NODE_ENV === 'development';
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const HOST = process.env.REACT_APP_SERVER_HOST;
export const SOCKET_HOST = process.env.REACT_APP_SOCKET_HOST;
